import { motion } from "framer-motion";
import React from "react";

function Aboutus() {
  // ----------------------------------------------  Animation Variants ----------------------------------------------

  const slideInFromLeft = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0, transition: { duration: 1 } },
  };

  const slideInFromRight = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0, transition: { duration: 1 } },
  };

  const verticalLineAnimation = {
    hidden: { scaleY: 0 },
    visible: { scaleY: 1, transition: { duration: 1, ease: "easeInOut" } },
  };

  // ----------------------------------------------  Animation Variants ----------------------------------------------

  return (
    <div className="w-full min-h-screen bg-cover bg-center flex justify-center items-center text-white overflow-hidden -z-50 lg:mb-[160px] md:mb-[120px] xs:mb-[40px]">
      <div className="lg:w-[calc(100%_-_90px)] xs:w-[calc(100%_-_30px)]">
        {/*  ----------------------- -----------------------bg image of aboutus ----------------------- ----------------------- */}
        <div className="font-faustina h-auto  xs:h-[200px] lg:h-[350px] md:h-[313px] sm:h-[280px]  w-full md:mt-[60px] xs:mt-[40px] bg-aboutus-bg  lg:rounded-[110px] md:rounded-[67px] xs:rounded-[50px] text-white flex flex-col justify-center items-center relative bg-cover bg-center bg-no-repeat">
          <div className="bg-inner absolute inset-0 bg-gradient-to-r from-[#1FA2FF] from-[0%] via-25% to-[#A6FFCB] to-[70%] opacity-20 lg:rounded-[110px] md:rounded-[67px] xs:rounded-[50px]"></div>
          <p className="font-bold md:text-[50px] sm:text-[40px] xs:text-[32px] mb-[10px]">
            Our History
          </p>
          <p className="font-medium text-xl lg:text-[32px] md:text-2xl xs:text-[18px] text-center">
            Everyone has a past - ours is simply more inspiring. Discover the
            journey behind Param Group.
          </p>
        </div>

        <div className="w-full font-poppins 1920:mt-[100px] md:mt-[60px] xs:mt-[40px]">
          <div className="relative w-full">
            {/*  ----------------------------------------------card 1 ---------------------------------------------- */}
            <div className="relative flex flex-col  lg:flex-row xs:items-start items-center xs:justify-start ">
              <motion.div
                className="flex flex-col  lg:text-end w-full lg:w-[23%]"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                variants={slideInFromLeft}
              >
                <h2 className="lg:text-[100px] xs:text-[clamp(50px,9.8vw,100px)] font-bold lg:bg-gradient-to-r xs:bg-gradient-to-tl from-[#1FA2FF] from-[70%] to-[#A6FFCB] to-[90%] text-transparent bg-clip-text">
                  01
                </h2>
                <h3 className="1800:text-[50px] 1400:text-[32px] 1200:text-[30px] 1080:text-[28px] lg:text-[26px] xs:text-[clamp(32px,2.9vw,50px)] font-bold lg:bg-gradient-to-r xs:bg-gradient-to-tl from-[#1FA2FF] from-[35%] to-[#A6FFCB] to-[100%] text-transparent bg-clip-text">
                  Who We Are
                </h3>
              </motion.div>
              <div className="flex flex-col lg:flex-col xs:flex-row  xs:justify-center xs:items-center lg:items-center ml-0 lg:ml-5 mt-[24px]">
                <div className="w-10 h-10 rounded-full bg-[#1FA2FF]"></div>
                <motion.div
                  className="line1 w-2  lg:w-2 sm:w-[300px] xs:w-[200px] lg:rounded-b-3xl xs:rounded-e-3xl  bg-gradient-to-b lg:bg-gradient-to-b xs:bg-gradient-to-r from-[#1FA2FF] from-[10%] to-[#A6FFCB] to-[90%]"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.5 }}
                  variants={verticalLineAnimation}
                  style={{
                    transformOrigin: "top",
                  }}
                ></motion.div>
              </div>
              <motion.div
                className="text-lg w-full lg:w-[75%] pl-0 lg:pl-8"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                variants={slideInFromRight}
              >
                <div className="text-justify leading-relaxed flex flex-col gap-5 font-poppins text-lg lg:text-xl whitespace-pre-line px-3 xs:py-4 mt-[15px] ">
                  <p>
                    Founded in 2001 and proudly growing our footprint in India
                    since 2021, Param Group of Companies has been driven by a
                    simple yet powerful vision: to harness innovative technology
                    that transforms lives and accelerates growth. As a trusted
                    IT solutions provider and technology consulting company, we
                    deliver secure, scalable, and cutting-edge solutions across
                    IT & consulting, education, healthcare, and social
                    development sectors
                  </p>
                  <p>
                    We empower businesses and communities by developing digital
                    transformation platforms, automating workflows to boost
                    operational efficiency, and delivering industry-aligned
                    upskilling and professional training programs tailored for
                    students and working professionals. Our commitment also
                    extends to supporting healthcare initiatives that enhance
                    patient care and promote healthier communities.
                  </p>
                  <p>
                    At the heart of everything we do are our core values
                    of transparency, inclusivity, excellence, and
                    a community-first approach. Guided by an experienced
                    leadership team with global expertise and local insights, we
                    craft technology solutions that not only meet client
                    objectives but also foster empowerment, innovation, and
                    positive social impact.{" "}
                  </p>
                  <p>
                    Understanding India’s vast talent potential, we
                    founded LaunchCrew—a vibrant, technology-driven learning
                    community created to inspire curiosity, nurture ambition,
                    and accelerate career growth for students and professionals
                    alike. LaunchCrew provides access to mentorship, practical
                    workshops, skill-building projects, and networking
                    opportunities, equipping learners with the tools they need
                    to succeed in India’s dynamic digital economy.
                  </p>
                  <p>
                    Choose Param Group as your partner for digital innovation,
                    AI integration, business consulting, employee upskilling,
                    and healthcare IT solutions. Together, we will build a
                    smarter, more connected future that empowers lives and
                    drives sustainable success
                  </p>
                </div>
              </motion.div>
            </div>
            {/*  ---------------------------------------------- card2 ----------------------------------------------  */}
            <div className="relative flex flex-col  lg:flex-row xs:items-start items-center xs:justify-start mt-[-5px]">
              <motion.div
                className="flex flex-col  lg:text-end w-full lg:w-[23%] lg:mt-[-25px]"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                variants={slideInFromLeft}
              >
                <h2 className="lg:text-[100px] xs:text-[clamp(50px,9.8vw,100px)] font-bold lg:bg-gradient-to-r xs:bg-gradient-to-tl from-[#1FA2FF] from-[70%] to-[#A6FFCB] to-[90%] text-transparent bg-clip-text">
                  02
                </h2>
                <h3 className="1800:text-[50px] 1400:text-[32px] 1200:text-[30px] 1080:text-[28px] lg:text-[26px] xs:text-[clamp(32px,2.7vw,50px)] font-bold lg:bg-gradient-to-tl xs:bg-gradient-to-tl from-[#1FA2FF] from-[35%] to-[#A6FFCB] to-[100%] text-transparent bg-clip-text ">
                  Our Core Value
                </h3>
              </motion.div>
              <div className="flex flex-col lg:flex-col xs:flex-row  xs:justify-center xs:items-center lg:items-center ml-0 lg:ml-5">
                <div className="w-10 h-10 rounded-full bg-[#1FA2FF]"></div>
                <motion.div
                  className="line2 w-2 lg:w-2 sm:w-[300px] xs:w-[200px] lg:rounded-b-3xl xs:rounded-e-3xl  bg-gradient-to-b lg:bg-gradient-to-b xs:bg-gradient-to-r from-[#1FA2FF] from-[10%] to-[#A6FFCB] to-[90%] "
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.5 }}
                  variants={verticalLineAnimation}
                  style={{
                    transformOrigin: "top",
                  }}
                ></motion.div>
              </div>
              <motion.div
                className="text-lg w-full lg:w-[75%] pl-0 lg:pl-8 "
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                variants={slideInFromRight}
              >
                <div className="text-justify leading-relaxed px-3 py-[12px] flex flex-col gap-5 font-poppins text-lg lg:text-xl whitespace-pre-line">
                  
                  <div className="flex flex-col gap-2">
                    <p className="text-xl lg:text-2xl font-bold">
                      Stronger when ‘UNITED’
                    </p>
                    <p>
                      Like it is
                      said, teamwork makes the dream work we at Param Group
                      consider employees our greatest resource, helping us achieve
                      milestones. A strong set of core values keeps our workforce
                      responsible to society and guided in the right direction.
                    </p>
               
                  </div>
                  <div className="flex flex-col gap-2">
                    <p className="text-xl lg:text-2xl font-bold">
                      Unity and Integrity
                    </p>
                    <p>
                      Inspired by the community’s trust in us, we unite as a
                      team to fulfill our clients’ objectives and help them
                      achieve true satisfaction. Setting differences aside, our
                      team works together to support people and improve the
                      environment as a whole. Strong business integrity and
                      ethical honesty in everything we say and do are part of
                      our core values. We believe in actions that reflect both
                      our integrity and our unity within society.
                    </p>
                  </div>
                  <div className="flex flex-col gap-2">
                    <p className="text-xl lg:text-2xl font-bold">
                      Respect for Individuals
                    </p>
                    <p>
                      Respecting the honest opinion of individuals working with
                      us and in the community. Maintaining confidentiality with
                      every client we deal with and treating each person in a
                      manner that depicts Param Group’s value. Supporting
                      individuals with disabilities and empowering them in
                      different ways.
                    </p>
                  </div>
                  <div className="flex flex-col gap-2">
                    <p className="text-xl lg:text-2xl font-bold">
                      Loyalty and Trust
                    </p>
                    <p>
                      Be a loyal and trustworthy partner for our clients. Share
                      constructive reports and feedback with stakeholders and
                      implement actions in favor of them. Become a reliable
                      partner in the community and take fair decisions that are
                      independent and unbiased.
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>
            {/*  ---------------------------------------------- card3 ----------------------------------------------  */}
            <div className="relative flex flex-col lg:flex-row xs:items-start items-center xs:justify-start mt-[-5px]">
              <motion.div
                className="flex flex-col lg:text-end w-full lg:w-[23%] lg:mt-[-25px]"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                variants={slideInFromLeft}
              >
                <h2 className="lg:text-[100px] xs:text-[clamp(50px,9.8vw,100px)] font-bold lg:bg-gradient-to-r xs:bg-gradient-to-tl from-[#1FA2FF] from-[70%] to-[#A6FFCB] to-[90%] text-transparent bg-clip-text">
                  03
                </h2>
                <h3 className="1800:text-[50px] 1400:text-[32px] 1200:text-[30px] 1080:text-[28px] lg:text-[26px] xs:text-[clamp(32px,2.9vw,50px)] font-bold lg:bg-gradient-to-r xs:bg-gradient-to-tl from-[#1FA2FF] from-[35%] to-[#A6FFCB] to-[100%] text-transparent bg-clip-text">
                  Our Purpose
                </h3>
              </motion.div>
              <div className="flex flex-col lg:flex-col xs:flex-row  xs:justify-center xs:items-center lg:items-center lg:ml-5">
                <div className="w-10 h-10 rounded-full bg-[#1FA2FF]"></div>
                <motion.div
                  className="line w-2 lg:w-2 sm:w-[300px] xs:w-[200px]  xl:h-[480px] 1920:h-[350px] lg:h-[480px] xs:h-2 bg-gradient-to-b lg:bg-gradient-to-b xs:bg-gradient-to-r from-[#1FA2FF] from-[10%] to-[#A6FFCB] to-[90%] lg:rounded-b-3xl xs:rounded-e-3xl"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.5 }}
                  variants={verticalLineAnimation}
                  style={{
                    transformOrigin: "top",
                  }}
                ></motion.div>
              </div>
              <motion.div
                className="text-lg w-full lg:w-[75%] pl-0 lg:pl-8"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                variants={slideInFromRight}
              >
                <div className="text-justify leading-relaxed  px-2 py-[12px] flex flex-col gap-5 font-poppins text-lg lg:text-xl whitespace-pre-line">
    
                  <p className="text-xl lg:text-2xl font-bold">
                    Care. Cater. Curate
                  </p>
                  <p>
                    Our purpose is very clear and uniquely drives us to fulfill
                    our vision and mission. Care means helping people in our
                    surroundings live better lives. Cater means helping clients
                    and the community solve their problems and achieve better
                    results. And curate means innovating in products and
                    services that take the healthcare industry by storm.
                  </p>
                  <p>
                    Our purpose at Param Group is to devise products and
                    services that not only offer value to the community but also
                    bring contentment in everything we do. Our vision is to
                    combine caregiving and technology in a way that delivers
                    unique and valuable benefits to the community. Driving
                    toward satisfaction is what we consider our primary purpose
                    at the company.
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Aboutus;
